module.exports = __webpack_public_path__ + "static/media/logo.53ce92ee.png";